import 'velocity-animate';

var $body = $('body');

$body.on('change', '.js-radio-toggle input', function () {

    var $this = $(this),
        id = $this.attr('id');

    // Find all children inside .js-radio-toggle
    $this.parents('fieldset').find('input').each(function() {
        // Hide each child
        hideSectionsWithId($(this).attr('id'));
    });

    // Show child(ren) that matches data-toggle-id
    showSectionsWithId(id);
});

$body.on('change', '.js-select-toggle', function(){

    var id = this.value;

    // Find all children inside .js-select-toggle
    $(this).find('option').each(function()
    {
        hideSectionsWithId($(this).val());
    });

    // Show child(ren) that matches data-toggle-id
    showSectionsWithId(id);
});

function hideSectionsWithId(sectionId){
    if(sectionId !== ""){
        $body.find('[data-toggle-id=' + sectionId + ']')
                .velocity('slideUp', { duration: 200 })
                .removeClass('is-active');
    }
}

function showSectionsWithId(sectionId){
    if(sectionId !== ""){
        $body.find('[data-toggle-id=' + sectionId + ']')
                .velocity('slideDown', { duration: 200 })
                .addClass('is-active');
        }
}